import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Collapse,
	Grid,
	Button
} from '@material-ui/core';

import TimeSelect from "./TimeSelect";
import LabeledRadioGroup from "./LabeledRadioGroup";
import WeekToggleButtons from "./WeekToggleButtons";

const styles = makeStyles(theme => ({
	paddedRow: {
		paddingLeft: "3%",
		paddingRight: "3%",
	},

	rowWidth: {
		width: "94%",
	},

	timeIcon: {
		paddingRight: theme.spacing(.5)
	}
}));

function AlertNotificationSchedule(props) {
	const scheduleStartValue = '12:00:00',
		scheduleEndValue = '21:00:00',
		alertSchedule = {same: "same", diff: "different"};

	let classes = styles(),
		paddedRowCls = `${classes.paddedRow} ${classes.rowWidth}`,
		{notificationConfig, settings, formChangeHandler, alertDaysButtonToggled, gotoProfile} = props,
		scheduleDays = [{
			name: "monday",
			dayValue: notificationConfig.monday_alerts,
			startName: "daily_alert_start_time_monday",
			startValue: notificationConfig.daily_alert_start_time_monday || scheduleStartValue,
			endName: "daily_alert_end_time_monday",
			endValue: notificationConfig.daily_alert_end_time_monday || scheduleEndValue
		},{
			name: "tuesday",
			dayValue: notificationConfig.tuesday_alerts,
			startName: "daily_alert_start_time_tuesday",
			startValue: notificationConfig.daily_alert_start_time_tuesday || scheduleStartValue,
			endName: "daily_alert_end_time_tuesday",
			endValue: notificationConfig.daily_alert_end_time_tuesday || scheduleEndValue
		},{
			name: "wednesday",
			dayValue: notificationConfig.wednesday_alerts,
			startName: "daily_alert_start_time_wednesday",
			startValue: notificationConfig.daily_alert_start_time_wednesday || scheduleStartValue,
			endName: "daily_alert_end_time_wednesday",
			endValue: notificationConfig.daily_alert_end_time_wednesday || scheduleEndValue
		},{
			name: "thursday",
			dayValue: notificationConfig.thursday_alerts,
			startName: "daily_alert_start_time_thursday",
			startValue: notificationConfig.daily_alert_start_time_thursday || scheduleStartValue,
			endName: "daily_alert_end_time_thursday",
			endValue: notificationConfig.daily_alert_end_time_thursday || scheduleEndValue
		},{
			name: "friday",
			dayValue: notificationConfig.friday_alerts,
			startName: "daily_alert_start_time_friday",
			startValue: notificationConfig.daily_alert_start_time_friday || scheduleStartValue,
			endName: "daily_alert_end_time_friday",
			endValue: notificationConfig.daily_alert_end_time_friday || scheduleEndValue
		},{
			name: "saturday",
			dayValue: notificationConfig.saturday_alerts,
			startName: "daily_alert_start_time_saturday",
			startValue: notificationConfig.daily_alert_start_time_saturday || scheduleStartValue,
			endName: "daily_alert_end_time_saturday",
			endValue: notificationConfig.daily_alert_end_time_saturday || scheduleEndValue
		},{
			name: "sunday",
			dayValue: notificationConfig.sunday_alerts,
			startName: "daily_alert_start_time_sunday",
			startValue: notificationConfig.daily_alert_start_time_sunday || scheduleStartValue,
			endName: "daily_alert_end_time_sunday",
			endValue: notificationConfig.daily_alert_end_time_sunday || scheduleEndValue
		}];

	return (
		settings && Object.keys(settings.times).length ?
			<React.Fragment>
				<LabeledRadioGroup
					row={true}
					id="alert_schedule_type"
					name="alert_schedule_type"
					aria-label="Alert Schedule Type"
					className={paddedRowCls}
					style={{marginLeft: '-12px'}}
					buttonColor={'primary'}
					value={notificationConfig.alert_schedule_type || alertSchedule.same}
					buttons={[{
						name: alertSchedule.same,
						label: "Same time for all days"
					},{
						name: alertSchedule.diff,
						label: "Allow different times for each day"
					}]}
					onChange={formChangeHandler} />
				<Collapse in={typeof notificationConfig.alert_schedule_type === 'undefined' || notificationConfig.alert_schedule_type === alertSchedule.same}>
					<TimeSelect
						allDay
						controlId="startFormControl"
						style={{marginTop: "10px"}}
						className={classes.paddedRow}
						ariaId="alert-start-helper-text"
						ariaLabel="start date"
						ariaText="Select the time of day when alert notifications should start"
						selectName="alertStartTimeSelect"
						id="alertStartTime"
						name="daily_alert_start_time"
						value={notificationConfig.daily_alert_start_time || scheduleStartValue}
						label="Start"
						onChange={formChangeHandler}
						settings={settings} />
					<TimeSelect
						controlId="endFormControl"
						disabled={!notificationConfig.daily_alert_start_time}
						style={notificationConfig.daily_alert_start_time === '24:00:00' ? {display: 'none'} : {marginTop: "10px"}}
						className={classes.paddedRow}
						ariaId="alert-end-helper-text"
						ariaLabel="end date"
						ariaText="Select the time of day when alert notifications should end"
						selectName="alertEndTimeSelect"
						id="alertEndTime"
						name="daily_alert_end_time"
						value={notificationConfig.daily_alert_end_time || scheduleEndValue}
						label="End"
						onChange={formChangeHandler}
						settings={settings}
						start={notificationConfig.daily_alert_start_time || scheduleStartValue} />
					<WeekToggleButtons
						id="alertWeekTogglers"
						style={{marginTop: "10px", marginBottom: "10px"}}
						className={paddedRowCls}
						buttonToggled={alertDaysButtonToggled}
						values={[
							notificationConfig.monday_alerts,
							notificationConfig.tuesday_alerts,
							notificationConfig.wednesday_alerts,
							notificationConfig.thursday_alerts,
							notificationConfig.friday_alerts,
							notificationConfig.saturday_alerts,
							notificationConfig.sunday_alerts,
						]} />
				</Collapse>
				<Collapse in={notificationConfig.alert_schedule_type === alertSchedule.diff}>
					<Grid
						container
						className={paddedRowCls}>
						<Grid item xs={2} xl={1}>
							<WeekToggleButtons
								id="alertWeekTogglers"
								style={{marginTop: "10px", marginBottom: "10px"}}
								className={paddedRowCls}
								buttonToggled={alertDaysButtonToggled}
								direction="column"
								values={[
									notificationConfig.monday_alerts,
									notificationConfig.tuesday_alerts,
									notificationConfig.wednesday_alerts,
									notificationConfig.thursday_alerts,
									notificationConfig.friday_alerts,
									notificationConfig.saturday_alerts,
									notificationConfig.sunday_alerts,
								]} />
						</Grid>
						<Grid item xs={10} xl={11}>
							{scheduleDays.length ? (
								scheduleDays.map((item, idx) => {
									return (
										<div key={idx}>
											<TimeSelect
												allDay
												controlId={`startFormControl-${idx}`}
												className={classes.paddedRow}
												disabled={item.dayValue ? false : true}
												style={idx === 0 ? {marginTop: "10px"} : null}
												ariaId={`alert-start-${idx}-helper-text`}
												ariaText={`Select the time of day when alert notifications should start on ${item.name}`}
												selectName={`alertStartTimeSelect-${idx}`}
												id={`alertStartTime-${idx}`}
												name={item.startName}
												value={item.startValue}
												label={idx === 0 ? "Start" : null}
												onChange={formChangeHandler}
												settings={settings} />
											<TimeSelect
												controlId={`endFormControl-${idx}`}
												className={classes.paddedRow}
												disabled={item.dayValue ? (item.startValue ? false : true) : true}
												style={item.startValue === '24:00:00' ? {display: 'none'} : idx === 0 ? {marginTop: "10px"} : null}
												ariaId={`alert-end-${idx}-helper-text`}
												ariaText={`Select the time of day when alert notifications should end on ${item.name}`}
												selectName={`alertEndTimeSelect-${idx}`}
												id={`alertEndTime-${idx}`}
												name={item.endName}
												value={item.endValue}
												label={idx === 0 ? "End" : null}
												onChange={formChangeHandler}
												settings={settings}
												start={item.startValue} />
										</div>
									);
								})
							) : null}
						</Grid>
					</Grid>
				</Collapse>
				<Button
					color="primary"
					className={classes.timeButton}
					onClick={gotoProfile}>
					Timezone Settings ({settings.user.timezone})
					<FontAwesomeIcon className={classes.timeIcon} icon={["fal", "clock"]} title="Timezone Settings" style={{marginLeft: 10}} />
				</Button>
			</React.Fragment> : null
	);
}

AlertNotificationSchedule.propTypes = {
	notificationConfig: PropTypes.object,
	settings: PropTypes.object,
	formChangeHandler: PropTypes.func.isRequired,
	alertDaysButtonToggled: PropTypes.func.isRequired,
	gotoProfile: PropTypes.func.isRequired
};

export default AlertNotificationSchedule;